import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/express',
  component: LAYOUT,
  name: 'Express',
  redirect: '/express/index',
  meta: {
    title: '物流信息',
  },
  children: [
    {
      path: 'index',
      name: 'ExpressIndex',
      meta: {
        title: '物流信息',
      },
      component: () => import('@/views/express/index'),
    },
  ],
};
